export const getArenaConfig = () => {
	const urlParams = new URLSearchParams(window.location.search);
	const alternativeHeaderRequested = urlParams.get('alternativeHeader') !== null;

	return {
		domainKey:                       window.arenaConfig?.domainKey || null,
		isSmartTv:                       window.$Helpers?.isSmartTV(),
		isAsport:                        window.isAsport,
		isSwissLeague:                   window.isSwissLeague || false,
		isStvFsg:                        window.isStvFsg || false,
		isSwissVolley:                   window.isSwissVolley || false,
		isSportAustria:                  window.isSportAustria || false,
		isOetv:                          window.isOetv || false,
		isSfl:                           window.isSfl || false,
		isKrone:                         window.isKrone || false,
		kroneOfferUrl:                   'https://www.krone.at/sportabo',
		upcomingEventIndex:              window.arenaConfig?.upcomingEventIndex ?? 1,
		showLeaguesAsSport:              window.arenaConfig?.showLeaguesAsSport || false,
		showTeamsAsSport:                window.arenaConfig?.showTeamsAsSport || false,
		disableLeagueMatchCenter:        window.arenaConfig?.disableLeagueMatchCenter || false,
		disableVideoCenter:              window.arenaConfig?.disableVideoCenter || false,
		enableSportsFilterInVideoCenter: window.arenaConfig?.enableSportsFilterInVideoCenter || false,
		enableDateFilterInVideoCenter:   window.arenaConfig?.enableDateFilterInVideoCenter || false,
		showEventCardTags:               window.arenaConfig?.showEventCardTags || false,
		headerImageLink:                 window.arenaConfig?.headerImageLink || null,
		enableLiveheader:                window.arenaConfig?.enableLiveheader || false,
		videoDownloadEnabled:            window.arenaConfig?.videoDownloadEnabled || false,
		imprint:                         window.arenaConfig?.imprint ?? 'asport',
		terms:                           window.arenaConfig?.terms ?? 'asport',
		about:                           window.arenaConfig?.about ?? null,
		headerImageUrl:                  window.arenaConfig?.headerImageUrl || null,
		footerImageUrl:                  window.arenaConfig?.footerImageUrl || null,
		socialMedia:                     window.arenaConfig?.socialMedia || [],
		cookieConsent:                   window.arenaConfig?.cookieConsent || false,
		cookieConsentRevisionNr:         window.arenaConfig?.cookieConsentRevisionNr || null,
		googleAnalyticsId:               window.arenaConfig?.googleAnalyticsId || null,
		menuItems:                       window.arenaConfig?.menuItems || null,
		additionalMenuItems:             window.arenaConfig?.additionalMenuItems || null,
		navigationSports:                window.arenaConfig?.navigationSports || null,
		enableNoSpoilerMode:             window.arenaConfig?.enableNoSpoilerMode || false,
		enableMomentsFeed:               window.arenaConfig?.enableMomentsFeed || false,
		enableVideoFeed:                 window.arenaConfig?.enableVideoFeed || false,
		alternativeHeader:               window.arenaConfig?.alternativeHeader || alternativeHeaderRequested,
		enableLogin:                     window.arenaParams?.enableLogin || false,
		enableLoginRedirect:             window.arenaParams?.enableLoginRedirect || false,
		followingEnabled:                window.arenaParams?.followingEnabled || false,
		type:                            window.arenaParams?.arenaContextableType || null,
		id:                              window.arenaParams?.arenaContextableId ?? null,
		isCustomDomain:                  window.arenaParams?.isCustomDomain || false,
		slug:                            window.arenaParams?.contextSlug || null,
		locales:                         window.arenaParams?.locales || [],
		hideSponsorsOnRoutes:            window.arenaParams?.hideSponsorsOnRoutes || [],
		paymentsEnabled:                 window.arenaParams?.paymentsEnabled ?? false,
		languages:                       window.arenaConfig?.languages || [],
		defaultLanguage:                 window.arenaParams?.defaultLanguage,
		currentLanguage:                 window.arenaParams?.currentLanguage,
		currentLanguageKey:              window.locale || 'en',
		showPoweredBy:                   window.arenaParams?.showPoweredBy || false,
		showFooterOnEvent:               window.arenaParams?.showFooterOnEvent || false,
		headerSponsorsColored:           window.arenaParams?.headerSponsorsColored || false,
		arenaInfos:                      window.arenaParams?.arenaInfos || null,
		csrfToken:                       window.arenaParams?.csrfToken || '',
		contactEmail:                    window.arenaParams?.contactEmail || '',
		loadArenaProfile:                window.arenaParams?.loadArenaProfile || false,
		navItems:                        window.arenaParams?.navItems || null,
		isLightTheme:                    document.body.classList.contains('-t-light'),
		theme:                           window.arenaParams?.theme || 'asport',
		subTheme:                        window.arenaParams?.subTheme || null,
		themeModifiers:                  window.arenaParams?.themeModifiers || [],
		geoblocking:                     window.arenaParams?.geoblocking || {},
		profileFields:                   window.arenaConfig?.profileFields || {},
		paymentOfferGroups:              window.arenaConfig?.paymentOfferGroups || null,
		hamburgerPosition:               window.arenaConfig?.hamburgerPosition || 'default',
		prominentMobileTopNav:           window.arenaConfig?.prominentMobileTopNav || false,
		autoplay:                        window.arenaConfig?.autoplay ?? true,
		primaryPreRollAdUrl:             window.arenaConfig?.primaryPreRollAdUrl ?? null,
		enableProfileCompletion:         window.arenaConfig?.enableProfileCompletion ?? false,
	};
};
